<template>
  <form class="SearchForm" onsubmit="return false;">
    <Icon class="SearchForm__icon" iconName="Search" />
    <input
      :id="id"
      class="SearchForm__form"
      type="text"
      :name="name"
      :aria-label="ariaLabel"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('inputWord', $event.target.value)"
    />
  </form>
</template>

<script>
import Icon from '@spectee/components/Atoms/IconBase/index.vue';

export default {
  name: 'SearchForm',
  components: { Icon },
  props: {
    name: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: '検索',
    },
    placeholder: {
      type: String,
      default: '検索',
    },
    value: {
      type: String,
      default: '',
    },
  },
  emits: ['inputWord'],
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.SearchForm {
  position: relative;
  height: $service-unit * 10;

  & &__icon {
    position: absolute;
    top: 50%;
    left: $service-unit * 4;
    width: $service-unit * 6;
    height: $service-unit * 6;
    color: $color-gray-60;
    stroke: $color-gray-60;
    stroke-width: 0.5;
    transform: translateY(-50%);
  }

  &__form {
    width: 100%;
    height: 100%;
    padding: 0 $service-unit * 4 0 $service-unit * 11;
    font-size: $service-font-size-pp;
    border: 1px solid $color-gray-50;
    border-radius: $service-border-radius;
    caret-color: $color-blue-60;
    appearance: none;

    &::-webkit-search-cancel-button {
      appearance: none;
    }

    &::placeholder {
      color: $color-gray-60;
    }

    &:hover {
      border: 1px solid $color-blue-60;
    }

    &:focus {
      outline: 2px solid $color-blue-60;
    }
  }

  @media (max-width: 768px) {
    & &__icon {
      top: 40%;
    }
    &__form {
      // width: 160%;
      height: 0;
      min-height: $service-unit * 8;
      font-size: $service-font-size-ppp;
    }
  }
}
</style>
